<div id="certificatePasswordModal" class="generic-confirm-modal">
  <div class="generic-confirm-modal__header">
    <h3 class="modal-title">Digital Certificate Access</h3>
  </div>
  <div class="generic-confirm-modal__body" [formGroup]="certificatePasswordValidationForm">
    <div class="description-message">
      Enter the password for your digital certificate. Once verified, it will be securely stored for
      future use.
    </div>
    <app-password-input
      data-private
      [dataTestId]="'cerificate-password'"
      [errorMessage]="validationMsg"
      [formControlRef]="passwordEntry"
      [label]="'Enter your Password'"
      [isFullWidth]="true"
      (keydown)="continueOnEnterKey($event)"
      >
    </app-password-input>
    @if (validationMsg) {
      <span class="certificate-password__support">
        Forgot your password? Call IdenTrust at <b>{{ idenTrustSupportPhone }}</b>.
      </span>
    }
  </div>
  <div class="generic-confirm-modal__footer">
    <app-button-container>
      <app-button
        type="tertiary"
        [isDisabled]="isLoading"
        (buttonClick)="cancel()"
        [dataTestId]="'cancel-certificate-password'"
        >
        Cancel
      </app-button>
      <app-button
        type="primary"
        [isDisabled]="isLoading"
        (buttonClick)="continue()"
        [dataTestId]="'continue-certificate-password'"
        >
        @if (!isLoading) {
          <span>Continue</span>
        }
        @if (isLoading) {
          <span class="fas fa-spin fa-circle-notch"></span>
        }
      </app-button>
    </app-button-container>
  </div>
</div>
